module.exports = __webpack_public_path__ + "img/circle-success.f11b79d0.svg";